import React from 'react'
import PropTypes from 'prop-types'

import { Container, Content } from './styles'

function Square({
  angle,
  display,
  horizontalAlign,
  isNotOnBody,
  size,
  verticalAlign,
}) {
  return (
    <Container
      bottom={verticalAlign[1]}
      display={display}
      left={horizontalAlign[0]}
      notOnBody={isNotOnBody}
      right={horizontalAlign[1]}
      size={size}
      top={verticalAlign[0]}
    >
      <Content angle={angle} />
    </Container>
  )
}

Square.defaultProps = {
  size: 600,
  angle: 0,
  isNotOnBody: false,
  verticalAlign: [0, null],
  horizontalAlign: [0, null],
  display: ['none', 'none', 'none', 'none', 'flex'],
}

Square.propTypes = {
  angle: PropTypes.number,
  display: PropTypes.arrayOf(PropTypes.oneOf(['none', 'flex'])),
  horizontalAlign: PropTypes.array,
  isNotOnBody: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  verticalAlign: PropTypes.array,
}

export default Square
